import { cva } from 'class-variance-authority';

const datePickerContainerBaseStyles = ['max-w-[400px]', 'shadow-md'];

const datePickerContainerSAG = cva([
  ...datePickerContainerBaseStyles,
  'bg-[#F3F3F0]',
  'dark:bg-[#23233C]',
]);

const datePickerContainerSHS = cva([
  ...datePickerContainerBaseStyles,
  'bg-white',
  'dark:bg-[#1a1a1a]',
]);

const datePickerButtonSAG = cva([
  'text-[#007993]',
  'hover:bg-[#E8E8E3]',
  'dark:text-[#00CCCC]',
  'dark:hover:bg-[#37374D]',
]);

const datePickerButtonSHS = cva([
  'text-[#666666]',
  'hover:text-[#1a1a1a]',
  'dark:text-[#999999]',
  'dark:hover:text-white',
]);

const datePickerTopTextBaseStyles = ['text-md', 'font-medium'];

const datePickerTopTextSAG = cva([
  ...datePickerTopTextBaseStyles,
  'text-[#007993]',
  'dark:text-[#00CCCC]',
]);

const datePickerTopTextSHS = cva([
  ...datePickerTopTextBaseStyles,
  'text-[#666666]',
  'dark:text-[#999999]',
]);

const datePickerDayTextBaseStyles = [
  'text-sm',
  'font-semibold',
  'select-none',
  'flex',
  'items-center',
  'justify-center',
  'aspect-square',
  'p-2',
];

const datePickerDayTextSAG = cva([
  ...datePickerDayTextBaseStyles,
  'text-[#000028]',
  'dark:text-white',
]);

const datePickerDayTextSHS = cva([
  ...datePickerDayTextBaseStyles,
  'text-[#666666]',
  'dark:text-[#999999]',
]);

const datePickerDayBoxBaseStyles = [
  'text-sm',
  'cursor-pointer',
  'select-none',
  'flex',
  'items-center',
  'justify-center',
  'aspect-square',
  'p-2',
];

const datePickerDisabledDayBoxSAG = cva([
  ...datePickerDayBoxBaseStyles,
  'text-[#66667E]',
  'dark:text-[#9999A9]',
]);

const datePickerDisabledDayBoxSHS = cva([
  ...datePickerDayBoxBaseStyles,
  'text-[#999999]',
  'dark:text-[#666666]',
]);

const datePickerDayBoxSAG = cva([
  ...datePickerDayBoxBaseStyles,
  'dark:text-[#00CCCC]',
  'dark:hover:bg-[#37374D]',
  'dark:data-[selected=true]:bg-[#00FFB9]',
  'dark:data-[selected=true]:text-[#000028]',
  'dark:data-[selected=true]:font-semibold',

  'text-[#007993]',
  'hover:bg-[#E8E8E3]',
  'data-[selected=true]:bg-[#196269]',
  'data-[selected=true]:text-white',
  'data-[selected=true]:font-semibold',
]);

const datePickerDayBoxSHS = cva([
  ...datePickerDayBoxBaseStyles,
  'dark:text-white',
  'dark:hover:bg-[#313131]',
  'dark:data-[selected=true]:bg-[#cf4b00]',
  'dark:data-[selected=true]:text-white',
  'dark:data-[selected=true]:font-semibold',

  'text-[#666666]',
  'hover:bg-[#E8E8E3]',
  'data-[selected=true]:bg-[#cf4b00]',
  'data-[selected=true]:text-white',
  'data-[selected=true]:font-semibold',
]);

const datePickerMonthBoxBaseStyles = [
  'text-sm',
  'cursor-pointer',
  'select-none',
  'flex',
  'items-center',
  'justify-center',
  'p-4',
];

const datePickerMonthBoxSAG = cva([
  ...datePickerMonthBoxBaseStyles,
  'dark:text-[#00CCCC]',
  'dark:hover:bg-[#37374D]',
  'dark:data-[selected=true]:bg-[#00FFB9]',
  'dark:data-[selected=true]:text-[#000028]',
  'dark:data-[selected=true]:font-semibold',

  'text-[#007993]',
  'hover:bg-[#E8E8E3]',
  'data-[selected=true]:bg-[#196269]',
  'data-[selected=true]:text-white',
  'data-[selected=true]:font-semibold',
]);

const datePickerMonthBoxSHS = cva([
  ...datePickerMonthBoxBaseStyles,
  'dark:text-white',
  'dark:hover:bg-[#313131]',
  'dark:data-[selected=true]:bg-[#cf4b00]',
  'dark:data-[selected=true]:text-white',
  'dark:data-[selected=true]:font-semibold',

  'text-[#666666]',
  'hover:bg-[#E8E8E3]',
  'data-[selected=true]:bg-[#cf4b00]',
  'data-[selected=true]:text-white',
  'data-[selected=true]:font-semibold',
]);

const datePickerTimeInputBaseStyles = [
  'border-none',
  'text-center',
  'text-md',
  'font-semibold',
  'p-2',
  'rounded-md',
  'w-[50px]',
  '[appearance:textfield]',
  '[&::-webkit-outer-spin-button]:appearance-none',
  '[&::-webkit-inner-spin-button]:appearance-none',
];

const datePickerTimeInputSAG = cva([
  ...datePickerTimeInputBaseStyles,
  'bg-[#E8E8E3]',
  'text-[#000028]',
  'dark:bg-[#37374D]',
  'dark:text-white',
]);

const datePickerTimeInputSHS = cva([
  ...datePickerTimeInputBaseStyles,
  'bg-white',
  'text-[#666666]',
  'dark:bg-[#1a1a1a]',
  'dark:text-[#999999]',
]);

const datePickerTimeDividerBaseStyles = ['text-lg', 'font-bold'];

const datePickerTimeDividerSAG = cva([
  ...datePickerTimeDividerBaseStyles,
  'text-[#000028]',
  'dark:text-white',
]);

const datePickerTimeDividerSHS = cva([
  ...datePickerTimeDividerBaseStyles,
  'text-[#666666]',
  'dark:text-[#999999]',
]);

const datePickerDividerSAG = cva(['border-[#E8E8E3]', 'dark:border-[#373750]']);

const datePickerDividerSHS = cva(['border-[#666666]', 'dark:border-[#999999]']);

export {
  datePickerContainerSAG,
  datePickerContainerSHS,
  datePickerButtonSAG,
  datePickerButtonSHS,
  datePickerTopTextSAG,
  datePickerTopTextSHS,
  datePickerDayTextSAG,
  datePickerDayTextSHS,
  datePickerDisabledDayBoxSAG,
  datePickerDisabledDayBoxSHS,
  datePickerDayBoxSAG,
  datePickerDayBoxSHS,
  datePickerMonthBoxSAG,
  datePickerMonthBoxSHS,
  datePickerTimeInputSAG,
  datePickerTimeInputSHS,
  datePickerTimeDividerSAG,
  datePickerTimeDividerSHS,
  datePickerDividerSAG,
  datePickerDividerSHS,
};
